import { render, staticRenderFns } from "./CompletedDate.vue?vue&type=template&id=2a1d1369&"
import script from "./CompletedDate.vue?vue&type=script&lang=js&"
export * from "./CompletedDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports